export const LEAK_FILTER = 'looxr.filter.leak';
export const ACTIVE_CUSTOMER = 'looxr.activecustomer';
